
import React from 'react';
import { X, Mail, UserPlus, Store, PhoneCall } from 'lucide-react';

interface ContactUsModalProps {
  onClose: () => void;
  organizerName?: string;
  organizerContact?: string;
}

const ContactUsModal: React.FC<ContactUsModalProps> = ({ onClose, organizerName, organizerContact }) => {
  const contactHref = organizerContact
    ? (organizerContact.includes('@') ? `mailto:${organizerContact}` : `tel:${organizerContact}`)
    : undefined;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-x-auto overflow-y-auto"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="bg-white dark:bg-[#1a2231] w-full max-w-[560px] sm:max-w-[600px] rounded-lg shadow-2xl relative flex flex-col max-h-[90vh] overflow-x-auto overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          aria-label="Close modal"
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors z-10 p-1 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="px-6 sm:px-8 pt-10 pb-6 flex flex-col items-center text-center w-full overflow-x-auto">
          <div className="mb-6 flex flex-col items-center gap-2">
            <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-2">
              <Store className="text-primary w-8 h-8" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold urbanist-brand bg-gradient-to-r from-black to-gray-700 dark:bg-gradient-to-r dark:from-white dark:to-gray-500 bg-clip-text text-transparent">{organizerName || 'Eventador'}</h2>
            <p className="text-[#4c669a] dark:text-slate-400 text-sm sm:text-base font-normal">How can we help you today?</p>
          </div>
          <div className="w-full flex flex-col gap-3">
            <button className="group w-full flex items-center justify-center gap-2 rounded-lg h-11 sm:h-12 px-5 bg-primary hover:bg-blue-700 active:bg-blue-800 transition-all text-[#f8f9fc] text-sm sm:text-base font-bold leading-normal tracking-[0.015em]">
              <Mail className="w-5 h-5" />
              <span>Send us a message</span>
            </button>
            <button className="group w-full flex items-center justify-center gap-2 rounded-lg h-11 sm:h-12 px-5 bg-[#e7ebf3] hover:bg-[#dce2ee] dark:bg-slate-700 dark:hover:bg-slate-600 dark:text-white text-[#0d121b] text-sm sm:text-base font-bold leading-normal tracking-[0.015em] transition-all">
              <UserPlus className="w-5 h-5" />
              <span>Sign up and be an organizer</span>
            </button>
          </div>
        </div>
        {organizerName && (
          <>
            <div className="w-full h-px bg-slate-100 dark:bg-slate-700"></div>
            <div className="bg-[#f8f9fc] dark:bg-[#151c2a] px-6 sm:px-8 py-8 flex flex-col items-center text-center w-full overflow-x-auto">
              <div className="w-16 h-16 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 flex items-center justify-center mb-4">
                <Store className="text-slate-400 dark:text-slate-500 w-8 h-8" />
              </div>
              <h3 className="text-[#0d121b] dark:text-white text-lg sm:text-xl font-bold mb-1">{organizerName}</h3>
              <p className="text-[#4c669a] dark:text-slate-400 text-xs sm:text-sm font-medium uppercase tracking-wide mb-6">Organizer</p>
              {organizerContact && contactHref && (
                <div className="w-full">
                  <div className="flex items-center justify-center gap-2 text-[#4c669a] dark:text-slate-400 mb-1">
                    <PhoneCall className="w-4 h-4" />
                    <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider">Contact us at</span>
                  </div>
                  <a
                    className="text-primary hover:text-blue-700 dark:hover:text-blue-400 text-base sm:text-lg font-bold underline decoration-primary/30 underline-offset-4 transition-colors break-all"
                    href={contactHref}
                  >
                    {organizerContact}
                  </a>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactUsModal;
